export enum ActualAuctionStatusEnum {
    Active = 1,
    Paused = 2,
    UserDisconnected = 4,
    BidAcceptance = 8,
    ReOffered = 16,
    Completed = 32,
    Withdrawn = 64,
    InvalidStatus = 128,
    Loading = 256,
    Pending = 512,
    ClosingShortly = 1024,
    IsPaused = Paused | UserDisconnected | InvalidStatus | Loading | Pending,
    IsRunning = Active | BidAcceptance | ReOffered | Completed | Withdrawn | ClosingShortly,
    NotRegistered = 2048,
    NotStarted = 4096
}
